import Vue from 'vue'

Vue.filter('strippedContent', (string) => {
  let result = string.replace(/<\/?[^>]+(>|$)/g, '')
  result = result.replace(/&nbsp;/gi, '')
  return result
})

Vue.filter('splitTextIntoLines', (text, lineCount, lettersInLine) => {
  let words = (text || '').trim().split(/\s+/g)

  if (!words[0]) {
    return ''
  }

  let lines = []

  for (let i = 0, line = '', prependSpace = false; words.length && i < lineCount; i++, line = '', prependSpace = false) {
    do {

      // текущая линия + пробел + следующее слово - все помещается
      if (line.length + words[0].length + (prependSpace ? 1 : 0) <= lettersInLine) {
        line += (prependSpace ? ' ' : '') + words.shift()
        prependSpace = true
        continue

        // следующее слово меньше заданного предела (поместится в пустой линии)
      } else if (words[0].length <= lettersInLine) {

        // текущая линия - последняя, поэтому конкатим это слово и заполняем линию
        if (i === lineCount - 1) {
          line += '...'
        }

        // переходим на следующую линию (или выходим из обрамляющего цикла, если она последняя)
        break

        // следующее слово длиннее даже пустой линии, поэтому дробим это слово, добавляя часть в текущую линию
      } else {
        let temp = lettersInLine - line.length - (prependSpace ? 1 : 0)

        line += (prependSpace ? ' ' : '') + words[0].substr(0, temp)

        // убираем добавленную в линию часть слова из этого слова
        words[0] = words[0].substr(temp)
      }

      break

    } while (words.length)

    lines[i] = line
  }

  return lines.join(' ')
})

export default {}
